import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';
import { API } from '../API';
import { Account } from '../Account';

import { faWindowMaximize, faSignOutAlt, faUserCog } from '@fortawesome/free-solid-svg-icons';

const _api = Symbol();
const _account = Symbol();
const _accountLoadHandler = Symbol();

export class AccountDisplay extends BaseElement {
	constructor() {
		super();
		this.library.add(faWindowMaximize, faSignOutAlt, faUserCog);

		this[_accountLoadHandler] = () => this.requestUpdate();
	}
	static get properties() {
		return { 
			account: { type: Account }
		};
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				.welcome {
					font-size: 0.85em;
					margin: 0.25em 0;
				}
				a {
					margin-right: 0.25em;
				}
			`
		];
	}
	connectedCallback() {
		super.connectedCallback();

		this.emit('get-account', { callback: account => this.account = account });
		this.emit('get-api', { callback: api => this.api = api });

		this.account.on('load', this[_accountLoadHandler]);
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		this.account.off(null, this[_accountLoadHandler]);

		this.account = null;
		this.api = null;
	}
	get api() {
		return this[_api];
	}
	set api(v) {
		if(v !== null && !(v instanceof API))
			throw new TypeError('api must be an instance of API.');
		this[_api] = v;
	}
	get account() {
		return this[_account];
	}
	set account(v) {
		if(v !== null && !(v instanceof Account))
			throw new TypeError('account must be an instance of Account.');
		this[_account] = v;
	}
	async handleLogout() {
		try {
			await this.api.logout();
		}
		catch(err) {
			console.error(err);
		}
	}
	render() {
		return html`
			<div class="welcome">Welcome, ${this.account.cn}.</div>
			<a href="/my-account" class="button">
				<i class="icon fas fa-user-cog"></i>
				My Account
			</a>
			<!-- <button @click="${() => this.emit('full-screen')}">
				<i class="icon fas fa-window-maximize"></i>
				Fullscreen
			</button> -->
			<button class="logout" @click="${() => this.handleLogout()}" type="button">
				<i class="icon fas fa-sign-out-alt"></i>
				Sign out
			</button>
		`;
	}
}

customElements.define('pp-account-display', AccountDisplay);